import { getWidgetAttributes } from '@sportal365/smp-widget-utils';
import { ROUND } from '../../../../../packages/constants/widgetIds';
import WidgetAttributes from '../../../../../packages/constants/widgetAttributes';

export const roundAttributes = getWidgetAttributes(
  ROUND,
  // REQUIRED
  [WidgetAttributes.WIDGET_ID, WidgetAttributes.WIDGET_SPORT, WidgetAttributes.WIDGET_TYPE, WidgetAttributes.COMPETITION],
  // OPTIONAL
  [
    WidgetAttributes.NAME_TYPE,
    WidgetAttributes.THEME,
    WidgetAttributes.LIMIT,
    WidgetAttributes.REFRESH_TIME,
    WidgetAttributes.ENTITY_LINKS,
    WidgetAttributes.STAGE,
    WidgetAttributes.ROUNDS,
    WidgetAttributes.LABELS,
    WidgetAttributes.SEASON,
    WidgetAttributes.ODDS_BETTING_ID,
    WidgetAttributes.ODDS_DISPLAY,
    WidgetAttributes.ODDS_MARKET,
    WidgetAttributes.ODDS_PRE_EVENT_ONLY,
    WidgetAttributes.ODDS_MARKET_VALUE_TYPE,
    WidgetAttributes.ALLOW_INLINE_ODDS,
    WidgetAttributes.DROPDOWN_DISPLAY,
    WidgetAttributes.ROUND,
    WidgetAttributes.SORT_DIRECTION,
    WidgetAttributes.HEADER_DISPLAY,
    WidgetAttributes.BETTING_BRAND_COLORS,
    WidgetAttributes.BETTING_LOGO_CLICK_ACTION,
    WidgetAttributes.BETTING_LOGO_OVERLAP,
    WidgetAttributes.DATA_DATE_FROM,
    WidgetAttributes.DATA_DATE_TO,
  ],
);
